var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenusContainer',{attrs:{"showBar":"","menus":_vm.menus}})
}
var staticRenderFns = []

export { render, staticRenderFns }